module.exports = "/images/Latam_v2.svg?f6d5d77b75bbd2dd6547115044ee7ba0";